export default {"src":"/_next/static/media/02_LuckySpin_PT.d3f46707.gif","height":175,"width":439};